import { printHtml } from "@/components/inventory/shelfPrint";
import html2pdf from "html2pdf.js";

const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const fmtN = (n, d = 0) => Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: d });
const fmt12h = (t) => {
  const [h, m] = String(t).split(":").map(Number);
  if (Number.isNaN(h)) return "";
  const ap = h >= 12 ? "PM" : "AM";
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${ap}`;
};
const fmtDate = (s) => {
  if (!s) return "";
  const d = new Date(String(s).length <= 10 ? `${s}T00:00:00` : s);
  return isNaN(d) ? s : d.toLocaleDateString();
};
const line = (w = 130) => `<span class="bl" style="min-width:${w}px"></span>`;
const lineGrow = `<span class="bl grow"></span>`;
const val = (v, w = 130) => (v ? `<b>${esc(v)}</b>` : line(w));
const cb = (checked) => `<span class="cb">${checked ? "✕" : ""}</span>`;

const NAVY = "#16337e";

const CSS = `
    .dop * { box-sizing: border-box; }
    .dop { font-family: 'Helvetica Neue', Arial, sans-serif; color: #0f172a; font-size: 10.5px; line-height: 1.35; }
    .dop .bl { display: inline-block; border-bottom: 1px solid #334155; height: 12px; vertical-align: bottom; }
    .dop .fx { display: flex; gap: 5px; align-items: flex-end; white-space: nowrap; }
    .dop .bl.grow { flex: 1 1 auto; min-width: 30px; }
    .dop .noteline { border-bottom: 1px solid #334155; height: 15px; }
    .dop .cb { display: inline-block; width: 12px; height: 12px; border: 1.4px solid ${NAVY}; text-align: center; font-size: 10px; font-weight: 800; line-height: 11px; vertical-align: -1px; margin-right: 5px; color: ${NAVY}; }
    .dop .hdrband { font-size: 9.5px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; color: ${NAVY}; background: #e9eff8; border: 1px solid #b6c4dd; padding: 3px 8px; }
    .dop .top { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 10px; }
    .dop .co .name { font-size: 17px; font-weight: 800; color: ${NAVY}; letter-spacing: -0.02em; }
    .dop .co div { color: #1e293b; }
    .dop .title-block { text-align: right; }
    .dop .title { font-size: 21px; font-weight: 800; color: ${NAVY}; letter-spacing: -0.01em; }
    .dop .subtitle { font-size: 11px; font-weight: 700; color: #1e293b; letter-spacing: 0.05em; margin-top: 2px; }
    .dop table.ref { width: 100%; border-collapse: collapse; margin-bottom: 10px; }
    .dop table.ref th { font-size: 8.5px; text-transform: uppercase; letter-spacing: 0.05em; color: ${NAVY}; background: #e9eff8; border: 1px solid #b6c4dd; padding: 3px 6px; }
    .dop table.ref td { border: 1px solid #b6c4dd; padding: 4px 6px; text-align: center; font-weight: 700; font-size: 11px; }
    .dop .row3 { display: flex; gap: 8px; margin-bottom: 8px; }
    .dop .box { border: 1px solid #b6c4dd; flex: 1; display: flex; flex-direction: column; }
    .dop .box .bhdr { font-size: 9px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; color: ${NAVY}; background: #e9eff8; border-bottom: 1px solid #b6c4dd; padding: 3px 8px; }
    .dop .box .bval { padding: 6px 8px; flex: 1; }
    .dop .box .bval .first { font-weight: 700; font-size: 11.5px; }
    .dop .box .fld { margin: 4px 0; white-space: nowrap; }
    .dop .box .fld .flbl { color: #334155; }
    .dop .carrier-box { flex: 1.35; }
    .dop .sec-icons .fld { margin: 6px 0; }
    .dop table.items { width: 100%; border-collapse: collapse; }
    .dop table.items th { font-size: 8.5px; text-transform: uppercase; letter-spacing: 0.05em; color: ${NAVY}; background: #f1f5fb; border: 1px solid #b6c4dd; padding: 4px 6px; text-align: left; }
    .dop table.items td { border: 1px solid #b6c4dd; padding: 5px 6px; vertical-align: top; }
    .dop table.items .band td { background: #e9eff8; border: 1px solid #b6c4dd; font-size: 9.5px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; color: ${NAVY}; padding: 3px 8px; }
    .dop .r { text-align: right !important; font-variant-numeric: tabular-nums; }
    .dop table.items .totals td { background: #f1f5fb; font-weight: 800; font-size: 11px; color: #0f172a; }
    .dop .row2 { display: flex; gap: 8px; margin-top: 8px; align-items: stretch; }
    .dop .note { flex: 1.2; border: 1px solid #d9c86a; background: #fefce8; padding: 6px 10px; font-size: 9.5px; color: #3f3a1c; }
    .dop .note .nhdr { font-weight: 800; text-transform: uppercase; letter-spacing: 0.05em; color: #7a6b13; margin-bottom: 3px; font-size: 9.5px; }
    .dop .sigs { display: flex; gap: 8px; margin-top: 8px; }
    .dop .sig { flex: 1; border: 1px solid #b6c4dd; }
    .dop .sig .shdr { font-size: 9px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.06em; color: ${NAVY}; background: #e9eff8; border-bottom: 1px solid #b6c4dd; padding: 3px 8px; }
    .dop .sig .sbody { padding: 6px 8px; }
    .dop .sig .legal { font-size: 8.3px; font-style: italic; color: #334155; margin-bottom: 8px; min-height: 42px; }
    .dop .sig .fld { margin: 7px 0 0; white-space: nowrap; font-size: 9.5px; color: #334155; }
    .dop .sig .fld .bl { min-width: 90px; width: 55%; }
    .dop .footbar { margin-top: 10px; border: 1.4px dashed ${NAVY}; padding: 5px 10px; text-align: center; }
    .dop .footbar .fb1 { font-size: 10px; font-weight: 800; color: ${NAVY}; }
    .dop .footbar .fb2 { font-size: 9px; color: #334155; margin-top: 1px; }
    .dop .gen { margin-top: 6px; font-size: 8px; color: #94a3b8; text-align: right; }
`;

const buildBody = (doc, company = {}, customer = null) => {
  const rows = (doc.lines || []).map((l) => `
    <tr>
      <td><b>${esc(l.product_name)}</b>${l.design_name ? `<div style="color:#334155">${esc(l.design_name)}</div>` : ""}</td>
      <td>${l.case_pack ? `${Math.round(l.case_pack)}-Pack` : "—"}</td>
      <td class="r">${l.cases != null ? fmtN(l.cases, 2) : "—"}</td>
      <td class="r">${l.pallets != null ? fmtN(l.pallets, 2) : "—"}</td>
      <td class="r">${l.bottles != null ? fmtN(l.bottles) : "—"}</td>
      <td>${esc(l.pallet_dims || "—")}${l.weight_per_pallet ? `<div style="color:#334155">${fmtN(l.weight_per_pallet, 1)} lbs/pallet</div>` : ""}</td>
      <td class="r">${l.weight_lbs != null ? fmtN(l.weight_lbs, 1) : "—"}</td>
    </tr>`).join("");
  const weight = doc.total_weight_lbs != null ? doc.total_weight_lbs : doc.computed_weight_lbs;
  const physPallets = doc.physical_pallets != null ? doc.physical_pallets : Math.ceil(doc.total_pallets || 0);
  const isComponent = doc.kind === "component";
  const unitsLabel = isComponent ? "Units" : "Bottles";
  const DIR_LABELS = { to_customer: "TO CUSTOMER", to_copacker: "TO CO-PACKER", from_supplier: "FROM SUPPLIER", to_warehouse: "TO WAREHOUSE", supplier_to_copacker: "SUPPLIER → CO-PACKER" };
  const dirLabel = DIR_LABELS[doc.direction || "to_customer"] || "TO CUSTOMER";
  const partyAddress = String(customer?.address ?? doc.partner_address ?? "");
  const partyLines = [customer?.company_name || doc.partner_name || doc.customer_name, ...partyAddress.split("\n")].map((s) => String(s || "").trim()).filter(Boolean);
  const companyLines = [company.company_name, company.address_line1, company.address_line2].filter(Boolean);
  const fromSupplier = doc.direction === "from_supplier";
  const shipFromParty = doc.ship_from_party
    ? [doc.ship_from_party.company_name, ...String(doc.ship_from_party.address || "").split("\n")].map((s) => String(s || "").trim()).filter(Boolean)
    : null;
  const custLines = doc.ship_to_override ? doc.ship_to_override.split("\n") : (fromSupplier ? companyLines : partyLines);
  const fromLines = doc.ship_from ? doc.ship_from.split("\n") : (shipFromParty || (fromSupplier ? partyLines : companyLines));
  const notesText = (doc.notes || "").trim();
  const destAddrs = customer?.addresses || [];
  const destHit = destAddrs.find((a) => a.id === doc.ship_address_id) || (destAddrs.length === 1 ? destAddrs[0] : null);
  const deliveryInstructions = fromSupplier ? "" : String(doc.delivery_instructions || destHit?.delivery_instructions || "").trim();
  const instrHtml = deliveryInstructions ? `<div style="padding:2px 0"><b>Delivery Instructions:</b> ${esc(deliveryInstructions).replace(/\n/g, "<br/>")}</div>` : "";
  const notesHtml = notesText ? `<div style="padding:2px 0">${esc(notesText).replace(/\n/g, "<br/>")}</div>` : "";
  const noteLines = instrHtml || notesHtml
    ? `${instrHtml}${notesHtml}`
    : `<div class="noteline"></div><div class="noteline"></div><div class="noteline"></div><div class="noteline"></div>`;
  const ft = doc.freight_terms || "";
  return `
    <div class="top">
      <div class="co">
        <div class="name">${esc(company.company_name || "")}</div>
        <div>${esc(company.address_line1 || "")}</div>
        <div>${esc(company.address_line2 || "")}</div>
        <div>${esc(company.phone || "")}</div>
      </div>
      <div class="title-block">
        <div class="title">STRAIGHT BILL OF LADING</div>
        <div class="subtitle">ORIGINAL – NOT NEGOTIABLE</div>
        <div style="margin-top:5px"><span style="display:inline-block;border:1.5px solid ${NAVY};color:${NAVY};font-size:9.5px;font-weight:800;letter-spacing:0.1em;padding:2px 10px">${dirLabel}</span></div>
      </div>
    </div>
    <table class="ref">
      <tr><th>BOL #</th><th>DO #</th><th>Sales Order #</th><th>Customer PO #</th><th>Ship / Pickup Date</th><th>RDD (Requested Delivery)</th></tr>
      <tr>
        <td>${esc(doc.bol_number || "—")}</td>
        <td>${esc(doc.do_number)}</td>
        <td>${esc(doc.so_number || "—")}</td>
        <td>${esc(doc.customer_po || doc.po_number || "—")}</td>
        <td>${fmtDate(doc.pickup_date) ? `${fmtDate(doc.pickup_date)}${doc.pickup_time ? ` ${fmt12h(doc.pickup_time)}` : ""}` : "—"}</td>
        <td>${fmtDate(doc.rdd) || "—"}</td>
      </tr>
    </table>
    <div class="row3">
      <div class="box"><div class="bhdr">Ship From</div><div class="bval">
        ${fromLines.map((l, i) => `<div class="${i === 0 ? "first" : ""}">${esc(l)}</div>`).join("") || "—"}
      </div></div>
      <div class="box"><div class="bhdr">Ship To</div><div class="bval">
        ${custLines.map((l, i) => `<div class="${i === 0 ? "first" : ""}">${esc(l)}</div>`).join("") || "—"}
        ${doc.customer_po ? `<div style="margin-top:4px"><b>Customer PO #: ${esc(doc.customer_po)}</b></div>` : ""}
      </div></div>
      <div class="box carrier-box"><div class="bhdr">Carrier / Transportation</div><div class="bval">
        <div class="fld"><span class="flbl">Carrier Name:</span> ${val(doc.carrier, 180)}</div>
        <div class="fld"><span class="flbl">Driver Name:</span> ${val(doc.driver_name, 180)}</div>
        <div class="fld"><span class="flbl">SCAC:</span> ${val(doc.scac, 70)} &nbsp; <span class="flbl">PRO / Tracking #:</span> ${val(doc.tracking_number, 95)}</div>
        <div class="fld"><span class="flbl">Tractor / Truck #:</span> ${val(doc.truck_number, 70)} &nbsp; <span class="flbl">Trailer #:</span> ${val(doc.trailer_number, 90)}</div>
        <div class="fld"><span class="flbl">NMFC Class:</span> ${val(doc.nmfc_class, 70)}</div>
      </div></div>
    </div>
    <div class="row3">
      <div class="box sec-icons"><div class="bhdr">Trailer / Security / Tracking</div><div class="bval">
        <div class="fld"><span class="flbl">Trailer #:</span> ${val(doc.trailer_number, 130)}</div>
        <div class="fld"><span class="flbl">Seal #:</span> ${val(doc.seal_number, 140)}</div>
        <div class="fld"><span class="flbl">Tracker ID #:</span> ${val(doc.tracker_id, 115)}</div>
      </div></div>
      <div class="box" style="flex:0.7"><div class="bhdr">Freight Terms</div><div class="bval">
        <div class="fld">${cb(ft === "prepaid")} Prepaid</div>
        <div class="fld">${cb(ft === "collect")} Collect</div>
        <div class="fld">${cb(ft === "third_party")} Third Party</div>
      </div></div>
      <div class="box" style="flex:0.8"><div class="bhdr">Delivery Appointment</div><div class="bval">
        <div class="fld" style="margin-top:8px"><span class="flbl">Date:</span> ${val(fmtDate(doc.delivery_appointment_date), 110)}</div>
        <div class="fld" style="margin-top:10px"><span class="flbl">Time:</span> ${val(doc.delivery_appointment_time, 110)}</div>
      </div></div>
      <div class="box" style="flex:1.3"><div class="bhdr">Special Instructions / Shipping Notes</div><div class="bval">
        ${noteLines}
      </div></div>
    </div>
    <table class="items">
      <tr class="band"><td colspan="7">Shipment Contents</td></tr>
      <tr>
        <th style="width:24%">Product</th><th>Pack</th><th class="r">Cases</th><th class="r">Pallets</th><th class="r">${unitsLabel}</th>
        <th style="width:20%">Pallet Dimensions (L × W × H) / Pallet Weight</th><th class="r">Total Weight (lbs)</th>
      </tr>
      ${rows}
      <tr class="totals">
        <td colspan="2">SHIPMENT TOTALS</td>
        <td class="r">${isComponent ? "—" : `${fmtN(doc.total_cases, 2)} CASES`}</td>
        <td colspan="2" style="text-align:center">${fmtN(physPallets)} PALLETS / HANDLING UNITS</td>
        <td style="text-align:center">${fmtN(doc.total_bottles)} ${unitsLabel.toUpperCase()}</td>
        <td class="r">${weight ? `${fmtN(weight, 1)} LBS` : "—"}</td>
      </tr>
    </table>
    <div class="row2">
      <div class="box" style="flex:1"><div class="bhdr">Loading &amp; Count Confirmation</div><div class="bval" style="display:flex;gap:24px">
        <div>
          <div style="font-weight:700;font-size:9px;text-transform:uppercase;letter-spacing:0.05em;color:${NAVY};margin-bottom:4px">Trailer Loaded By:</div>
          <div class="fld">${cb(doc.trailer_loaded_by === "shipper")} Shipper</div>
          <div class="fld">${cb(doc.trailer_loaded_by === "driver")} Driver</div>
        </div>
        <div>
          <div style="font-weight:700;font-size:9px;text-transform:uppercase;letter-spacing:0.05em;color:${NAVY};margin-bottom:4px">Freight Counted By:</div>
          <div class="fld">${cb(doc.freight_counted_by === "shipper")} Shipper</div>
          <div class="fld">${cb(doc.freight_counted_by === "driver")} Driver</div>
        </div>
      </div></div>
      <div class="note">
        <div class="nhdr">⚠ Note to Carrier</div>
        Carrier acknowledges receipt of packages and required placards. Carrier certifies emergency response information
        was made available and/or carrier has the DOT emergency response guidebook or equivalent documentation in the
        vehicle. Property described above is received in good order, except as noted.
      </div>
    </div>
    <div class="sigs">
      <div class="sig"><div class="shdr">Shipper</div><div class="sbody">
        <div class="legal">This is to certify that the above-named materials are properly classified, packaged, marked and labeled, and are in proper condition for transportation according to the applicable regulations of the DOT.</div>
        <div class="fld fx">Signature: ${lineGrow}</div>
        <div class="fld fx">Printed Name: ${lineGrow}</div>
        <div class="fld fx">Date / Time: ${lineGrow}</div>
      </div></div>
      <div class="sig"><div class="shdr">Carrier / Driver (Receipt)</div><div class="sbody">
        <div class="legal">Received, subject to the classifications and tariffs in effect on the date of shipment. Shipper certifies the contents of this shipment are as described above.</div>
        <div class="fld fx">Signature: ${lineGrow}</div>
        <div class="fld fx">Printed Name: ${lineGrow}</div>
        <div class="fld fx">Date / Time (Pickup): ${lineGrow}</div>
      </div></div>
      <div class="sig"><div class="shdr">Consignee (Delivery / POD)</div><div class="sbody">
        <div class="legal">Received the above shipment in apparent good order unless otherwise noted.</div>
        <div class="fld fx">Signature: ${lineGrow}</div>
        <div class="fld fx">Printed Name: ${lineGrow}</div>
        <div class="fld fx">Date / Time (Delivery): ${lineGrow}</div>
      </div></div>
    </div>
    <div class="footbar">
      <div class="fb1">IMPORTANT: Freight charges are PREPAID unless marked COLLECT or THIRD PARTY.</div>
      <div class="fb2">Subject to the terms and conditions of the applicable carrier's tariff and the Uniform Straight Bill of Lading.</div>
    </div>
    <div class="gen">Generated ${new Date().toLocaleString()} — ${esc(doc.bol_number || doc.do_number)}</div>`;
};

export const printDeliveryOrder = (doc, company = {}, customer = null) => {
  const html = `<html><head><title>${esc(doc.bol_number || doc.do_number)} — Straight Bill of Lading</title><style>
    body { margin: 24px; }
    ${CSS}
    @media print { body { margin: 8mm; } }
  </style></head><body><div class="dop">${buildBody(doc, company, customer)}</div></body></html>`;
  printHtml(html);
};

export const downloadDeliveryOrderPdf = async (doc, company = {}, customer = null) => {
  const wrap = document.createElement("div");
  wrap.style.cssText = "position:fixed;left:-10000px;top:0;width:790px;background:#ffffff;";
  wrap.innerHTML = `<style>${CSS}</style><div class="dop">${buildBody(doc, company, customer)}</div>`;
  document.body.appendChild(wrap);
  try {
    await html2pdf().set({
      margin: [8, 8, 8, 8],
      filename: `${doc.bol_number || doc.do_number || "bill-of-lading"}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, backgroundColor: "#ffffff" },
      jsPDF: { unit: "mm", format: "letter", orientation: "portrait" },
      pagebreak: { mode: ["css", "legacy"] },
    }).from(wrap.querySelector(".dop")).save();
  } finally {
    wrap.remove();
  }
};
